export default __webpack_public_path__ + "static/media/90cfbaabcaf5b0acee2d44c476ddb29b.svg";